"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Radio = _interopRequireDefault(require("@material-ui/core/Radio"));
var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));
var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));
var _RadioGroup = _interopRequireDefault(require("@material-ui/core/RadioGroup"));
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var RadioGroup = props => {
  var classes = (0, _styles.default)(props);
  var {
    values,
    selectedValue,
    handleChange,
    label,
    name,
    ariaLabel
  } = props;
  return /*#__PURE__*/_react.default.createElement(_FormControl.default, {
    component: "fieldset",
    className: classes.container
  }, label, /*#__PURE__*/_react.default.createElement(_RadioGroup.default, {
    "aria-label": ariaLabel,
    name: name,
    value: selectedValue,
    onChange: handleChange,
    color: 'secondary'
  }, values.map((value, index) => /*#__PURE__*/_react.default.createElement(_FormControlLabel.default, {
    key: index,
    value: value,
    control: /*#__PURE__*/_react.default.createElement(_Radio.default, null),
    label: value
  }))));
};
var _default = exports.default = RadioGroup;